import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';

import { RequestStatus, Job, DocumentSegment, OfferAllocation, Offer, NGXLogger } from '@app/shared';
import { JobService } from '@app/core';
import {
  JobActionTypes,
  GetJobs,
  GetJobsSuccess,
  GetJobsFailure,
  SetJob,
  SetJobSuccess,
  SetJobFailure,
  GetJobPages,
  GetJobPagesSuccess,
  GetJobPagesFailure,
  AddPagesToRegion,
  AddPagesToRegionSuccess,
  AddPagesToRegionFailure,
  AssignTeamAndOfferAlloc,
  AssignTeamAndOfferAllocSuccess,
  AssignTeamAndOfferAllocFailure,
  UpdateJob,
  UpdateJobSuccess,
  UpdateJobFailure,
  CopyJob,
  CopyJobSuccess,
  CopyJobFailure,
  SetJobLock,
  SetJobLockSuccess,
  SetJobLockFailure,
  SwapSegments,
  SwapSegmentsSuccess,
  SwapSegmentsFailure,
  GetJobStudioFiles,
  GetJobStudioFilesSuccess,
  GetJobStudioFilesFailure,
  DeleteJob,
  DeleteJobSuccess,
  DeleteJobFailure,
  CopyFullJob,
  CopyFullJobSuccess,
  CopyFullJobFailure,
  ValidateProject,
  ValidateProjectSuccess,
  ValidateProjectFailure,
  GetPageBackgrounds,
  GetPageBackgroundsSuccess,
  GetPageBackgroundsFailure,

} from '../actions/job.actions';


@Injectable()
export class JobEffects {

  constructor(
    private actions: Actions,
    private jobService: JobService,
    private router: Router,
    private logger:NGXLogger
  ) { }

  // effects go here
/*  @Effect()
  GetJob:Observable<any>= this.actions
    .ofType(AuthActionTypes.LOGIN)
    .map((action: LogIn) => action.payload)
    .switchMap(payload => {
      return this.userService.auth(payload.email, payload.password)
        .map((user) => {
          this.logger.debug(user);
          return new LogInSuccess({token: user.token, email: payload.email});
        })
        .catch((error) => {
          this.logger.debug(error);
          return Observable.of(new LogInFailure({ error: error }));
        });
    });*/

    @Effect()
    GetJobs: Observable<any> = this.actions
        .ofType(JobActionTypes.GET_JOBS)
        .debounceTime(10)
        .map((action: GetJobs) => action.payload)
        .switchMap(payload => {
          return this.jobService.getJobs(payload.project.uuid)
            .map((result) => {
              let jobs = [];
              //this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
            //  let jobs = [];
              //for(let tmpJob of result.data){
                //  let job = Object.assign( new Job(), tmpJob );
                //  job.documentSegments = job.documentSegments as DocumentSegment[];
                  // job.documentSegments.map(ds => {
                  //   ds = ds
                  //   ds.publicOffers.map(o => o = Object.assign( new Offer(), o ));
                  //   ds.offerAllocation.map(oa => {
                  //     oa = Object.assign( new OfferAllocation(), oa )
                  //     oa.publicOffers.map(o => o = Object.assign( new OfferAllocation(), oa ));
                  //   });

                    // ds.offerAllocation.map(oa =>{
                    //   oa.team = this.jobUtils.getTeamFromName(oa.department,this.teams);
                    // });
                    //
                    // ds.publicOffers.map(oa =>{
                    //   oa.team = this.jobUtils.getTeamFromName(oa.department,this.teams);
                    // });
                    //
                    // if(ds.offerAllocation)
                    //   ds.offerAllocation.sort((a,b) => a.pagePosition - b.pagePosition);

                //  })

                  //jobs.push(job);
            //  }

              //this.logger.debug(jobs)
              result.data.map(job => {
                let tmpJob = Object.assign(new Job(), job);
                var docSegs = [];
                job.documentSegments.map(ds => {
                  let tmpDS = Object.assign(new DocumentSegment(), ds);
                  docSegs.push(tmpDS);
                })
                tmpJob.documentSegments = docSegs;
                jobs.push(tmpJob)
              });
              return new GetJobsSuccess({jobs:jobs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to save the Campaign."

              return Observable.of(new GetJobsFailure({ errorStatus: rs }));
            });
        })



    @Effect({ dispatch: false })
    GetJobsSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_JOBS_SUCCESS),
      tap((result) => {

        // for(let i = 0; i< result.payload.jobs.length; i++){
        //   result.payload.jobs[i].pageOfferCount = JSON.parse(result.payload.jobs[i].pageOfferCount);
        // }
        this.logger.debug(result, ' in tap')
        //this.logger.debug(result)
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetJobsFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_JOBS_FAILURE)
    );


    @Effect()
    UpdateJob: Observable<any> = this.actions
        .ofType(JobActionTypes.UPDATE_JOB)
        .debounceTime(10)
        .map((action: GetJobs) => action.payload)
        .switchMap(payload => {
          return this.jobService.updateJob(payload.job)
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              rs.msg = `Region has been saved`;

              return new UpdateJobSuccess({job:result.data,successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to save the Region."

              return Observable.of(new UpdateJobFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    UpdateJobSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.UPDATE_JOB_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    UpdateJobFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.UPDATE_JOB_FAILURE)
    );



    @Effect()
    CopyJob: Observable<any> = this.actions
        .ofType(JobActionTypes.COPY_JOB)
        .map((action: CopyJob) => action.payload)
        .switchMap(payload => {
          return this.jobService.copyJob(payload.jobs,payload.includeOffers,payload.includeTeams)
            .map((result) => {
              this.logger.debug(result);
              // add the job to the list of jobs
              let job : Job = result.data[0];
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Region has been copied`;

              return new CopyJobSuccess({successStatus:rs, job:job})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to add to copy the region."
              return Observable.of(new CopyJobFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    CopyJobSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.COPY_JOB_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    CopyJobFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.COPY_JOB_FAILURE)
    );


    @Effect()
    SetJobLock: Observable<any> = this.actions
        .ofType(JobActionTypes.SET_JOB_LOCK)
        .map((action: CopyJob) => action.payload)
        .switchMap(payload => {
          return this.jobService.setJobLock(payload.job.uuid,payload.job.lockStatus)
            .map((result) => {
              this.logger.debug(result);
              // add the job to the list of jobs
              let job : Job = result.data[0];
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              let status :string = payload.job.lockStatus === "T"?'locked':'unlocked';
              rs.code = result.code;
              rs.msg = `Region has been ${status}`;

              return new SetJobLockSuccess({successStatus:rs, job:job})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to lock the region."
              return Observable.of(new SetJobLockFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    SetJobLockSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SET_JOB_LOCK_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    SetJobLockFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SET_JOB_LOCK_FAILURE)
    );


    // Job Pages
    @Effect()
    GetJobPages: Observable<any> = this.actions
        .ofType(JobActionTypes.GET_JOB_PAGES)
        .map((action: GetJobPages) => action.payload)
        .switchMap(payload => {
          this.logger.debug(payload, ' payload')
          return this.jobService.getJobPages(payload.job.uuid)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
                return new GetJobPagesSuccess({pages:result.data, job:payload.job, pauseState: payload.pauseState })
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetJobPagesFailure({ error: error }));
            });
        });


    @Effect({ dispatch: false })
    GetJobPagesSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_JOB_PAGES_SUCCESS),
      tap((result) => {

        this.logger.debug(result, ' get job page sucecess');
        // set the jobs pages

        result.payload.job.pages = result.payload.pages;

        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    GetJobPagesFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_JOB_PAGES_FAILURE)
    );



    // SETTING CURRENT Job
    @Effect()
    /*SetJob: Observable<any> = this.actions
        .ofType(JobActionTypes.SET_JOB)
        .map((action: GetJobs) => action.payload)
        .switchMap(payload => {
          return this.jobService.getJob(payload.job)
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new SetJobSuccess({selectedJob:payload.job})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SetJobFailure({ error: error }));
            });
        });*/


    @Effect({ dispatch: false })
    SetJobSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SET_JOB_SUCCESS),
      tap((result) => {

        this.logger.debug(result, ' SET JOB')
        // localStorage.setItem('token', user.payload.token);
        // this.router.navigateByUrl('/main');
      })
    );

    @Effect({ dispatch: false })
    SetJobFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SET_JOB_FAILURE)
    );


    @Effect()
    AddPagesToRegion: Observable<any> = this.actions
        .ofType(JobActionTypes.ADD_PAGES_TO_REGION)
        .debounceTime(10)
        .map((action: AddPagesToRegion) => action.payload)
        .switchMap(payload => {
          let regionName = payload.region?payload.region.name:null;

          return this.jobService.addPagesToRegion(payload.job.uuid, payload.pages, regionName)
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "Pages have been added";

              return new AddPagesToRegionSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetJobsFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    AddPagesToRegionSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.ADD_PAGES_TO_REGION_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    AddPagesToRegionFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.ADD_PAGES_TO_REGION_FAILURE)
    );


    @Effect()
    AssignTeamAndOfferAlloc: Observable<any> = this.actions
        .ofType(JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC)
        .debounceTime(10)
        .map((action: AssignTeamAndOfferAlloc) => action.payload)
        .switchMap(payload => {
          let regionName = payload.region?payload.region.name:null;

          return this.jobService.assignTeamsAndOfferAlloc(payload.allocations)
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "Teams and Offers have been asssigned";

              return new AssignTeamAndOfferAllocSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new AssignTeamAndOfferAllocFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    AssignTeamAndOfferAllocSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    AssignTeamAndOfferAllocFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.ASSIGN_TEAM_AND_OFFER_ALLOC_FAILURE)
    );


    @Effect()
    SwapSegments: Observable<any> = this.actions
        .ofType(JobActionTypes.SWAP_SEGMENTS)
        .debounceTime(10)
        .map((action: SwapSegments) => action.payload)
        .switchMap(payload => {

          return this.jobService.swapSegments(payload.jobs, payload.documentSegments[0],payload.documentSegments[1])
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "Document Segments have been swapped";

              return new SwapSegmentsSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new SwapSegmentsFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    SwapSegmentsSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SWAP_SEGMENTS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    SwapSegmentsFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.SWAP_SEGMENTS_FAILURE)
    );


    @Effect()
    GetJobStudioFiles: Observable<any> = this.actions
        .ofType(JobActionTypes.GET_STUDIO_FILES)
        .debounceTime(10)
        .map((action: SwapSegments) => action.payload)
        .switchMap(payload => {

          return this.jobService.getJobStudioFiles(payload.jobs)
            .map((result) => {
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = "File received";

              return new GetJobStudioFilesSuccess({successStatus:rs})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetJobStudioFilesFailure({ error: error }));
            });
        })

    @Effect({ dispatch: false })
    GetJobStudioFilesSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_STUDIO_FILES_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetJobStudioFilesFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_STUDIO_FILES_FAILURE)
    );

    @Effect()
    DeleteJob: Observable<any> = this.actions
        .ofType(JobActionTypes.DELETE_JOB)
        .map((action: CopyJob) => action.payload)
        .switchMap(payload => {
          return this.jobService.deleteJob(payload.job)
            .map((result) => {
              this.logger.debug(result);
              if(result.data && result.data.length && result.data[0].type && result.data[0].type === 'ERROR'){
                let es:RequestStatus = new RequestStatus();
                es.msg = result.data[0].message;
                return new DeleteJobFailure({ errorStatus: es });

              }else{
                // add the job to the list of jobs
                let job : Job = null;
                let rs : RequestStatus = new RequestStatus();

                rs.code = result.code;
                rs.msg = `Region has been removed`;

                return new DeleteJobSuccess({successStatus:rs, job:job})
              }
              
            })
            .catch((error) => {
              console.log(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.msg?error.msg:error.statusText;
              
              return Observable.of(new DeleteJobFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    DeleteJobSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.DELETE_JOB_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    DeleteJobFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.DELETE_JOB_FAILURE)
    );

    @Effect()
    CopyFullJob: Observable<any> = this.actions
        .ofType(JobActionTypes.COPY_FULL_JOB)
        .map((action: CopyFullJob) => action.payload)
        .switchMap(payload => {
          return this.jobService.copyFullJob(payload.project,payload.jobs,payload.includeOffers,payload.includeTeams)
            .map((result) => {
              this.logger.debug(result);
              // add the job to the list of jobs
              let job : Job = result.data[0];
              let rs : RequestStatus = new RequestStatus();

              rs.code = result.code;
              rs.msg = `Plan has been copied`;

              return new CopyFullJobSuccess({successStatus:rs, job:job})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to copy plan."
              return Observable.of(new CopyFullJobFailure({ errorStatus: rs }));
            });
        });

    @Effect({ dispatch: false })
    CopyFullJobSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.COPY_FULL_JOB_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    CopyFullJobFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.COPY_FULL_JOB_FAILURE)
    );

    // Project Validation
    @Effect()
    ValidateProject: Observable<any> = this.actions
        .ofType(JobActionTypes.VALIDATE_PROJECT)
        .map((action: ValidateProject) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.jobService.validateProject(payload.project.code, payload.project.uuid)
            .map((result) => {
              this.logger.debug(result.data);
              let rs : RequestStatus = new RequestStatus();
              rs.code = result.code;
              if(result.data[0] === 'failure'){
                return new ValidateProjectSuccess({successStatus:result.data})
              }else{
                rs.msg = `This code is already in use`;
                return new ValidateProjectFailure({ error: rs })
              }
              //return new LogInSuccess({token: user.token, email: payload.email});

            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = error.statusText;
              return Observable.of(new ValidateProjectFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    ValidateProjectSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.VALIDATE_PROJECT_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    ValidateProjectFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.VALIDATE_PROJECT_FAILURE),
    );

    // PAGE BACKGROUNDS
    @Effect()
    GetPageBackgrounds: Observable<any> = this.actions
        .ofType(JobActionTypes.GET_PAGE_BACKGROUNDS)
        .map((action: GetPageBackgrounds) => action.payload)
        .debounceTime(10)
        .switchMap(payload => {
          return this.jobService.getPageBackgrounds()
            .map((result) => {
              this.logger.debug(result.data);
              //return new LogInSuccess({token: user.token, email: payload.email});
              return new GetPageBackgroundsSuccess({pageBackgrounds:result.data})
            })
            .catch((error) => {
              let es:RequestStatus = new RequestStatus();
              es.msg = 'Problem fetching the Page Backgrounds';
              return Observable.of(new GetPageBackgroundsFailure({ error: es }));
            });
        });


    @Effect({ dispatch: false })
    GetPageBackgroundsSuccess: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_PAGE_BACKGROUNDS_SUCCESS),
      tap((result) => {
        this.logger.debug(result)
      })
    );

    @Effect({ dispatch: false })
    GetPageBackgroundsFailure: Observable<any> = this.actions.pipe(
      ofType(JobActionTypes.GET_PAGE_BACKGROUNDS_FAILURE),
    );


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/job.effects.ts